<template>
  <div class="assets-mapbox">
    <v-card>
      <v-card-text style="height:100%;width:100%" ref="container">
        <div id="map" style="width: 100%; height: 100%;"></div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

export default {
  data: () => ({
    map: null,
    mapZoom: 18,
    // mapBearing: 0,
    controlGeolocate: null,
    controlNavigation: null
  }),
  watch: {
    mapZoom(value) {
      if (this.controlGeolocate) {
        // Update geolocate fitbounds zoom option
        // So map won't zoom in/out when toggling geolocate (active state)
        this.controlGeolocate.options.fitBoundsOptions.zoom = value;
      }
    }
  },
  mounted() {
    // Map
    mapboxgl.accessToken =
      "pk.eyJ1Ijoic2l0ZXZpdGFscyIsImEiOiJjanR6bWoyaXUzNXkxNGRtc3ZjdGU3dHd3In0.YRJo-ei2_kKc7dOJXv4bzg";
    this.map = new mapboxgl.Map({
      container: "map",
      style: "mapbox://styles/mapbox/streets-v11", // stylesheet location
      center: [174.762192, -36.84845], // starting position [lng, lat]center: [-73.5804, 45.53483],
      pitch: 60, // pitch in degrees
      // bearing: this.mapBearing, // bearing in degrees
      zoom: this.mapZoom
    });
    console.log(this.map);
    // Map events
    this.map.on("load", () => {
      console.info("[event - load]");
      // Activate geolocate on load
      this.controlGeolocate.trigger();

      // 3D buildings
      // The 'building' layer in the mapbox-streets vector source contains building-height data from OpenStreetMap.
      // Insert the layer beneath any symbol layer.
      let layers = this.map.getStyle().layers;
      let labelLayerId;
      for (var i = 0; i < layers.length; i++) {
        if (layers[i].type === "symbol" && layers[i].layout["text-field"]) {
          labelLayerId = layers[i].id;
          break;
        }
      }
      this.map.addLayer(
        {
          id: "3d-buildings",
          source: "composite",
          "source-layer": "building",
          filter: ["==", "extrude", "true"],
          type: "fill-extrusion",
          minzoom: 15,
          paint: {
            "fill-extrusion-color": "#aaa",
            // use an 'interpolate' expression to add a smooth transition effect to the
            // buildings as the user zooms in
            "fill-extrusion-height": [
              "interpolate",
              ["linear"],
              ["zoom"],
              15,
              0,
              15.05,
              ["get", "height"]
            ],
            "fill-extrusion-base": [
              "interpolate",
              ["linear"],
              ["zoom"],
              15,
              0,
              15.05,
              ["get", "min_height"]
            ],
            "fill-extrusion-opacity": 0.6
          }
        },
        labelLayerId
      );
    });
    this.map.on("moveend", () => {
      console.info("[event - moveend]");
    });
    this.map.on("zoomend", () => {
      console.info("[event - zoomend]");
      this.mapZoom = this.map.getZoom();
    });

    // Navigation control
    this.controlNavigation = new mapboxgl.NavigationControl();
    this.map.addControl(this.controlNavigation, "top-right");

    // Geolocate control
    this.controlGeolocate = new mapboxgl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true
      },
      trackUserLocation: true,
      fitBoundsOptions: {
        linear: true,
        zoom: this.mapZoom
      }
    });
    this.map.addControl(this.controlGeolocate, "top-right");

    // Geolocate events
    let hasPoints = false;
    this.controlGeolocate.on("geolocate", event => {
      console.info("[event - geolocate]", event);

      // this.zoom = this.map.getZoom();
      // this.mapBearing = this.mapBearing + 10;

      // this.map.rotateTo(this.mapBearing);
      // this.map.easeTo({ lat: event.coords.latitude, lon: event.coords.longitude, bearing: this.mapBearing });

      if (event.coords.heading) {
        // Bearing is outdated by 1 step because geolocate fitBounds is being called first before geolocate event
        event.target.options.fitBoundsOptions.bearing = event.coords.heading;
      }
      // event.target.options.fitBoundsOptions.zoom = this.zoom;

      // this.map.rotateTo(90);
      // if (event.heading) {
      //   this.map.setBearing(event.heading);
      // }

      // Generate random points
      if (!hasPoints) {
        let features = [];
        let loop = 0;
        let max = 200;

        for (; loop < max; loop++) {
          let signLat = Math.round(Math.random()) ? 1 : -1;
          let signLng = Math.round(Math.random()) ? 1 : -1;
          let addLat =
            ((Math.floor(Math.random() * 50) + 5) / 100 / 100) * signLat;
          let addLng =
            ((Math.floor(Math.random() * 50) + 5) / 100 / 100) * signLng;

          features.push({
            type: "Feature",
            properties: {},
            geometry: {
              type: "Point",
              coordinates: [
                event.coords.longitude + addLng,
                event.coords.latitude + addLat
              ]
            }
          });
        }

        // Create geojson source
        this.map.addSource("points", {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features
          }
        });

        // Add geojson source to map
        this.map.addLayer({
          id: "points",
          type: "circle",
          source: "points",
          paint: {
            "circle-color": "#e53935",
            "circle-stroke-color": "#b71c1c",
            "circle-stroke-width": 2
          }
        });

        hasPoints = true;
      }
    });
  }
};
</script>

<style lang="scss">
.assets-mapbox {
  height: 100%;
  .v-card {
    height: 100%;
    .v-card__text {
      height: 100%;
    }
  }
}
</style>
